import { render, staticRenderFns } from "./public-course.vue?vue&type=template&id=3407060a"
import script from "./public-course.vue?vue&type=script&lang=js"
export * from "./public-course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports